import { render, staticRenderFns } from "./hospitalPiece.vue?vue&type=template&id=ff19488c&scoped=true"
import script from "./hospitalPiece.vue?vue&type=script&lang=js"
export * from "./hospitalPiece.vue?vue&type=script&lang=js"
import style0 from "./hospitalPiece.vue?vue&type=style&index=0&id=ff19488c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff19488c",
  null
  
)

export default component.exports